import { render, staticRenderFns } from "./login.vue?vue&type=template&id=6517b581&"
import script from "./login.vue?vue&type=script&lang=js&"
export * from "./login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6517b581')) {
      api.createRecord('6517b581', component.options)
    } else {
      api.reload('6517b581', component.options)
    }
    module.hot.accept("./login.vue?vue&type=template&id=6517b581&", function () {
      api.rerender('6517b581', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/auth/login.vue"
export default component.exports